module.exports = __webpack_public_path__ + "static/index/img/baikal-205.b7f3276c.jpg";